module.exports = __webpack_public_path__ + "static/img/8.c79ef60.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/3/4/1/sp/8.png
// module id = go++
// module chunks = 0